
define('text!templates/views/SearchControls.html',[],function () { return '<div id="searchControlsView" class="searchControlsView">\n    <button class="btn btn-large btn-danger btn-restart pull-left">Start Over</button>\n    <button class="btn btn-large btn-primary btn-search pull-right">Search</button>\n    <button class="btn btn-large btn-save pull-right">Save</button>\n</div>';});

